<template>
  <nav class="mt-1 bg-white w-full rounded-bl-[50px] rounded-br-[50px] flex flex-col p-4 space-y-3">
    <div v-for="item in menuItems" :key="item.key">
      <button
        :class="buttonClasses(item)"
        @click.stop="() => handleMenuItemClick(item)"
      >
        <div class="flex items-center space-x-2">
          <PContent class="font-bold">
            {{ item.name }}
          </PContent>
          <FancyAnimatePoint 
            v-if="hasSubmenu(item)" 
            :size="5" 
            :oscillate="true" 
          />
        </div>
        
        <svg 
          v-if="hasSubmenu(item)"
          :class="arrowClasses(item)" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      <div 
        v-if="hasSubmenu(item)"
        :class="submenuContainerClasses(item)"
      >
        <MobileSubmenu 
          v-if="activeSubmenu === item.key && item.submenu" 
          :items="item.submenu" 
        />
      </div>
    </div>

  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import PContent from '@/components/atoms/text/PContent.vue'
import FancyAnimatePoint from '@/components/atoms/animations/FancyAnimatePoint.vue'
import MobileSubmenu from './MobileSubmenu.vue'
import { cn } from '@/lib/utils'
import type { MobileMenuItem } from '../types/mobileNavigation'

interface Props {
  menuItems: MobileMenuItem[]
  activeSubmenu: string | null
}

const props = defineProps<Props>()

const emit = defineEmits<{
  submenuToggle: [menuKey: string, hasSubmenu: boolean]
}>()

const handleMenuItemClick = (item: MobileMenuItem) => {
  if (hasSubmenu(item)) {
    console.log('🔄 [MobileMenu] Toggle submenu:', item.key, 'Current active:', props.activeSubmenu)
    emit('submenuToggle', item.key, true)
  } else {
    if (item.onClick) {
      item.onClick()
    } else if (item.href) {
      window.location.href = item.href
    }
  }
}

const hasSubmenu = (item: MobileMenuItem) => {
  return item.submenu && item.submenu.length > 0
}

const buttonClasses = (item: MobileMenuItem) => 
  cn(
    'w-full flex items-center justify-between p-3 rounded-lg font-medium text-left transition-all duration-200 hover:bg-gray-50',
    props.activeSubmenu === item.key ? 'bg-blue-50 text-primary' : 'text-gray-700'
  )

const arrowClasses = (item: MobileMenuItem) => 
  cn(
    'w-4 h-4 transition-transform duration-200',
    props.activeSubmenu === item.key ? 'rotate-180' : ''
  )

const submenuContainerClasses = (item: MobileMenuItem) => 
  cn(
    'overflow-hidden transition-all duration-300 ease-in-out',
    props.activeSubmenu === item.key ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
  )
</script>

<style scoped>
/* Styles additionnels si nécessaire */
</style>

